import TAXApi from './_taxApi';
import httpClient from '@/apis/base/httpclient';

class TACircularVATDeclarationAPI extends TAXApi {
  constructor() {
    super();
  }
  controllerName = 'TACircularVATDeclarations';

  /**
   * Hàm lấy danh sách thuế cần phải nộp
   * @returns
   * NHANH3 5.1.2023
   */
  async GetTaxMustPay() {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + '/TaxMustPay',
    };

    return await httpClient.postAsync(request);
  }

  /**
   * Hàm lấy dữ liệu sinh chứng từ nộp thuế GTGT
   * @param {*} payload
   * @returns
   * NHANH3 6.1.2023
   */
  async GetDataVoucherGeneratePayTax(payload) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + '/DataGenerateVoucher',
      data: payload,
    };

    return await httpClient.postAsync(request);
  }

  /**
   * Lấy ra tờ khai lập lần cuối
   * @param {*} payload
   * @returns
   * tvhien 09.01.2023
   */
  async getTACircularVATLasted(payload) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + '/getTACircularVATLasted',
      data: payload,
    };

    return await httpClient.getAsync(request);
  }

  /**
   * Lấy ra tờ khai lập theo năm và tháng
   * @param {*} payload
   * @returns
   * tvhien 09.01.2023
   */
  async getTACircularVATByYearAndMonth(payload) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + '/getTACircularVATByYearAndMonth',
      data: payload,
    };

    return await httpClient.getAsync(request);
  }

  /**
   * Lấy danh sách chứng từ thiếu điều kiện
   * @param {*} payload
   * @returns
   * NNLINH 13.01.2023
   */
  async GetDataInvalidate(payload) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + '/DataInvalidate',
      data: payload,
    };

    return await httpClient.postAsync(request);
  }

  /**
   * Lấy danh sách chứng từ thiếu mua hàng với hóa đơn thường
   * @param {*} payload
   * @returns
   * NNLINH 27.01.2023
   */
  async GetPurchaseWithAllInvoice(payload) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + '/PurchaseWithAllInvoice',
      data: payload,
    };

    return await httpClient.postAsync(request);
  }

  /**
   * Thêm mới bảng kê mua vào/bán ra
   * @param {*} payload
   * @returns
   * NNLINH 27.01.2023
   */
  async GetNewPurchaseSaleList(payload) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + '/PurchaseSaleList',
      data: payload,
    };

    return await httpClient.postAsync(request);
  }

  /**
   * Lấy chứng từ thỏa mãn PL 43/2022
   * @param {*} payload
   * @returns
   * dqvinh 1.2.2022
   */
  async GetTaVATDeclarationAppendix(payload) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + '/GetTaVATDeclarationAppendix',
      data: payload,
    };

    return await httpClient.postAsync(request);
  }

  /**
   * Danh sách chứng từ chọn lại
   * @param {*} payload
   * @returns
   * NNLINH 27.01.2023
   */
  async GetDataChoose(payload) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + '/PurchaseSalelistChoose',
      data: payload,
    };

    return await httpClient.postAsync(request);
  }

  /**
   * Xuất khẩu báo cáo Xml
   * NHANH3 17.1.2023
   */
  export(param) {
    let request = {
      url: this.getAPIUrl() + '/Export',
      data: param,
    };

    return httpClient.postAsync(request);
  }

  /**
   * Lấy về thông tin thuế GTGT
   * @param {*} param
   * @returns
   * npcuong 10.01.2022
   */
  async getVATInfo(payload) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + '/GetVATInfo',
      data: payload,
    };

    return await httpClient.postAsync(request);
  }

  /**
   * Xử lý sinh mới một chứng từ nghiệp vụ khác
   * @param {*} payload
   * @returns
   * npcuong 18.01.2023
   */
  async generateGLGeneralVoucher(payload) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + '/GenerateGLGeneralVoucher',
      data: payload,
    };

    return await httpClient.postAsync(request);
  }

  /**
   * Kiểm tra xem đã thực hiện khấu trừ thuế tại kỳ hiện tại chưa
   * npcuong 03.02.2023
   */
  async checkIsDeductionTax(payload) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + '/CheckIsDeductionTax',
      data: payload,
    };

    return await httpClient.postAsync(request);
  }

  /**
   * Lấy ra tất cả tờ khai lập theo năm và tháng
   * @param {*} payload
   * @returns
   * tvhien 30.01.2023
   */
  async getAllTACircularVATByYearAndMonth(payload) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + '/GetAllTACircularVATByYearAndMonth',
      data: payload,
    };

    return await httpClient.getAsync(request);
  }
}

export default new TACircularVATDeclarationAPI();
